var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14996_1014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7947 8.70542C12.2342 9.14487 12.2342 9.85854 11.7947 10.298L5.04473 17.048C4.60527 17.4874 3.8916 17.4874 3.45215 17.048C3.0127 16.6085 3.0127 15.8949 3.45215 15.4554L9.40762 9.49995L3.45566 3.54448C3.01621 3.10503 3.01621 2.39136 3.45566 1.9519C3.89512 1.51245 4.60879 1.51245 5.04824 1.9519L11.7982 8.7019L11.7947 8.70542Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14996_1014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 18,
    fill: "white",
    transform: "translate(0.875 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightSolid);
export default __webpack_public_path__ + "static/media/chevron-right-solid.7e68e59f67b7ed1e7f4ee37eaaeee8ba.svg";
export { ForwardRef as ReactComponent };